import { motion } from "framer-motion";
import { Reveal, staggerContainer, staggerItem } from "@/components/site/Reveal";

const STEPS = [
  { n: "01", title: "Cuéntanos qué necesitas", desc: "Una llamada de 15 minutos para conocer tu negocio y elegir tus funciones." },
  { n: "02", title: "Te asignamos tu asistente", desc: "Una persona fija que aprende tu forma de trabajar, no un equipo rotativo." },
  { n: "03", title: "Delega desde el primer día", desc: "Empiezas a delegar tus tareas en menos de 48 horas." },
];

export default function StepsSection() {
  return (
    <section id="como-funciona" className="scroll-mt-24 bg-brand-bgAlt py-20 sm:py-24" data-testid="steps-section">
      <div className="mx-auto max-w-6xl px-6">
        <Reveal className="text-center text-[13px] uppercase tracking-[0.12em] text-brand-gray">
          Cómo funciona
        </Reveal>
        <Reveal className="mx-auto mt-3 max-w-2xl text-center text-3xl sm:text-4xl font-medium tracking-tight text-brand-ink">
          Empieza a delegar en 3 pasos
        </Reveal>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-40px" }}
          className="mt-14 grid gap-px overflow-hidden rounded-[14px] border border-brand-line bg-brand-line md:grid-cols-3"
        >
          {STEPS.map((s) => (
            <motion.div
              key={s.n}
              variants={staggerItem}
              className="bg-white p-8"
              data-testid={`step-${s.n}`}
            >
              <span className="text-5xl font-medium tracking-tight text-brand-indigo/25">{s.n}</span>
              <h3 className="mt-5 text-[18px] font-medium text-brand-ink">{s.title}</h3>
              <p className="mt-2 text-[14px] leading-relaxed text-[#5F5E5A]">{s.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
